import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
	FeaturedClearingVisitWebsite,
	FeaturedPostgraduate,
	FeaturedUndergraduate,
} from '@uc/web/shared/data-models';
import { ApplicationDeadlineComponent } from '../application-deadline/application-deadline.component';
import { CourseInformationTableRowComponent } from '../course-information-table-row/course-information-table-row.component';
import { HeadingComponent } from '@uc/shared/ui';
import { ClearingVisitWebsiteBtnComponent } from '@web/shared/ui';
import { Product } from '@uc/shared/data-models';

@Component({
	selector: 'uc-course-profile-application-details',
	templateUrl: './course-profile-application-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		HeadingComponent,
		ApplicationDeadlineComponent,
		ClearingVisitWebsiteBtnComponent,
		CourseInformationTableRowComponent,
	],
})
export class CourseProfileApplicationDetailsComponent {
	courseName = input.required<string>();
	uniName = input.required<string>();
	courseCode = input<string>('');
	institutionCode = input.required<string>();
	entryPoints = input.required<string[]>();
	applicationDeadline = input.required<string>();
	clearingCourseEnabled = input.required<boolean>();
	product = input.required<Product>();
	uniId = input.required<number>();
	searchOrder = input.required<number | null>();
	isFeatured = input.required<
		FeaturedUndergraduate | FeaturedPostgraduate | FeaturedClearingVisitWebsite
	>();
	privacyPolicyUrl = input.required<string | null>();
	currentClearingYear = input<number>();
	externalUrl = input<string | undefined>('');
}
